export const generateUTMParams = (tab, subtab) => {
  if (!subtab) {
    subtab = "default";
  }
  const content = {
    home: {
      default: "PORTAL_NUDGE_001",
      MFC: "PORTAL_NUDGE_MFC_Home",
    },
    Insights: {
      default: "PORTAL_NUDGE_002",
      Sales: "PORTAL_NUDGE_002",
      Menu: "PORTAL_NUDGE_003",
      Customers: "PORTAL_NUDGE_004",
    },
    Finance: {
      default: "PORTAL_NUDGE_005",
      Transactions: "PORTAL_NUDGE_005",
    },
    Menu: {
      default: "PORTAL_NUDGE_006",
      "Menu Overview": "PORTAL_NUDGE_006",
      MFC: "PORTAL_NUDGE_MFC_Menu"
    },
    Inventory: {
      default: "PORTAL_NUDGE_007",
      Item: "PORTAL_NUDGE_007",
    },
  }[tab][subtab];

  const params = {
    Source: "naas",
    Medium: "mexPortal",
    Name: "MMProUpsell",
    Content: content,
  };

  return "?" + new URLSearchParams(params).toString();
};
